import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter, Link as RouterLink } from "react-router-dom";
import classNames from "classnames";
import { List } from "immutable";
import formatServerUrl from "utils/URL";
import Confirm from "app/components/Confirm";
import Image from "components/base/Image";
import { formatLongDate } from "utils/date/formatDate";
import Button, { SolidButton } from "components/Button";
import SVG from "components/base/SVG";
import { campaignPath } from "app/routes";
import { selectProfile } from "data/user";
import { saveCampaign, selectCampaign, selectLoading, CampaignTypes } from "data/campaigns";
import Activities from "./Activities";
import css from "./style.scss";
import css2 from "../style.scss";
import rocketImage from "../../../assets/images/rocket.png";
import ProgressBar from "./ProgressBar";
import EndCampaignModal from "../../AccountNew/modals/EndCampaignModal";
import css3 from "../../../app/AccountNew/style.scss"
import formatDate from "../../../utils/date/formatDate";
import CampaignTable from "./CampaignTable";
import DirectMailCampaignStats from "app/Campaigns/Dashboard/DirectMail/DirectMailStats";
import { selectDirectMailCampaignStatsFor } from "data/campaigns/selectors";
import DirectMailUpgradeBanner from "./UpgradeBanner";
import { ContactAssignmentPopup } from "../../components/GroupAssignment";
import notificationalert from "../../../assets/images/notificationalert.svg";


const totals = [
  {
    icon: "iconLead",
    caption: "Total Leads",
    field: "recipientTotal"
  },
  {
    icon: "iconIdCard",
    caption: "Total Mailers Sent",
    field: "totalPiecesMailed"
  },
  {
    icon: "iconWebsiteVisits",
    caption: "Total Website Visits",
    prop: ["website", "visitQuantity"]
  },
  {
    icon: "iconLeadsContacted",
    caption: "Total Leads Contacted",
    type: CampaignTypes.DIALER,
    field: "deliveredQuantity"
  }
];

class Dashboard extends PureComponent {
  constructor(props) {
    super(props);

    this.handleEditName = this.handleEditName.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleCancelName = this.handleCancelName.bind(this);
    this.handleSaveName = this.handleSaveName.bind(this);
    this.handleToggleCampaign = this.handleToggleCampaign.bind(this);

    this.state = {
      id: null,
      totals: null,
      name: null,
      dialer: true,
      showEndCampaignModal: false,
      viewMode: {
        DIALER: "card",
        EMAIL: "card",
        POSTCARD: "card"
      }
    };
  }

  componentDidMount() {
    this.processProps(this.props);
  }

  componentWillReceiveProps(props) {
    this.processProps(props);
  }

  getIconForType = (type) => {
    if (type.code === CampaignTypes.DIALER.code) {
      return 'iconDialer';
    } else if (type.code === CampaignTypes.POSTCARD.code) {
      return 'iconPostcardNew';
    } else if (type.code === CampaignTypes.DIRECTMAIL.code) {
      return 'iconPostcardNew';
    } else if (type.code === CampaignTypes.EMAIL.code) {
      return 'iconEmail';
    }
    return null;
  };

  processProps(props) {
    const { campaign, loading } = props;
    const id = campaign.get("id");
    const recipientTotal = campaign.get("recipientTotal", 0);
    if (!loading && id && id !== this.state.id) {
      this.setState({
        totals: totals.map(({ icon, caption, prop, type, field }) => ({
          icon,
          caption,
          field,
          // "Total Mailers Sent" is not copied into state: render() reads it from the stats of the
          // campaign on screen, so it cannot lag behind a campaign switch.
          value:
            field === "recipientTotal"
              ? recipientTotal
              : field === "totalPiecesMailed"
                ? null
                : prop
                  ? campaign.getIn(prop, 0)
                  : campaign
                    .get("campaigns", List())
                    .filter(c => !type || c.get("type") === type.code)
                    .reduce((v, c) => v + c.get(field, 0), 0)
        }))
      });
    }
  }

  handleViewToggle = (type, mode) => {
    this.setState(prev => ({
      viewMode: {
        ...prev.viewMode,
        [type]: mode
      }
    }));
  };

  handleEditName() {
    this.setState({ name: this.props.campaign.get("name") });
  }

  handleNameChange(ev) {
    this.setState({ name: ev.target.value });
  }

  handleCancelName() {
    this.setState({ name: null });
  }

  handleSaveName(ev) {
    const { campaign, saveCampaign, confirm } = this.props;
    const name = this.state.name.trim();

    ev.preventDefault();

    if (name === "")
      confirm({ cancelLabel: null, question: "Please enter a name." });
    else
      saveCampaign(
        campaign.set("name", this.state.name),
        this.handleCancelName
      );
  }

  handleConfirmToggleCampaign = () => {
    const { campaign, saveCampaign } = this.props;
    const active = campaign.get("active");
    saveCampaign(campaign.set("active", !active));
    this.setState({ showEndCampaignModal: false });
  };

  handleToggleCampaign() {
    this.setState({ showEndCampaignModal: true });
  }

  handleCloseEndCampaignModal = () => {
    this.setState({ showEndCampaignModal: false });
  };

  getProcessedCampaigns = (campaigns, id) => {
    return campaigns.map(item => {
      const type = CampaignTypes[item.get("type")];
      const publishDate = item.get("publishDate");
      const sizeName = item.get("sizeName");
      const externalId = item.get("externalId");
      const externalStatus = item.get("externalStatus");
      const status = item.get("status");
      const isProgressInactive = status === "CANCELLED";
      const isActive = status === "NEW" || status === "PROCESSING";
      const isDialer = item.get("type") === CampaignTypes.DIALER.code;
      const active = (isDialer && isActive) || publishDate;

      return { item, type, publishDate, sizeName, externalId, externalStatus, status, isProgressInactive, isActive, isDialer, active };
    });
  };

  render() {
    const { campaign, children, loading, directMailStats } = this.props;
    const { name, totals } = this.state;

    // directMailStats is null until the stats of the campaign on screen are loaded, which renders as "—".
    const displayedTotals = totals && totals.map((total) => (
      total.field === "totalPiecesMailed"
        ? { ...total, value: directMailStats?.totalPiecesMailed ?? null }
        : total
    ));

    const id = campaign.get("id");
    const website = campaign.get("website");
    const websiteId = website.get("id");
    const active = campaign.get("active");
    const campaigns = campaign.get("campaigns", List());
    const url = website ? website.get("url") : "";
    const websiteActive = website.get("active");
    const postcardCampaigns = campaigns.filter(
      c => c.get("type") === CampaignTypes.POSTCARD.code
    );
    return (
      <div className={css.dashboard}>
        {children}
        <div className={classNames(css2.header, css.header)}>
          <div className={css2.left}>
            {name != null ? (
              <div>
                <div className={css2.modalOverlay} onClick={this.handleCancelName}>
                  <div className={css2.modalContainer} onClick={(e) => e.stopPropagation()}>
                    <h2 className={css2.modalTitle}>Marketing Campaign Name</h2>

                    <input
                      type="text"
                      autoComplete="off"
                      className={css2.modalInput}
                      value={name}
                      onChange={this.handleNameChange}
                    />

                    <div className={css2.modalActions}>
                      <Button
                        className={css2.cancelButton}
                        onClick={this.handleCancelName}
                      >
                        Cancel
                      </Button>

                      <Button
                        className={css2.saveButton}
                        onClick={this.handleSaveName}
                        disabled={!name || !name.trim()}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </div>
                <div className={css2.title}>
                  <div>{campaign.get("name")}</div>
                  <SVG
                    icon="iconEditCampaign"
                    className={css.editIcon}
                    onClick={this.handleEditName}
                  />
                </div>
              </div>
            ) : (
              <div className={css2.title}>
                <div>{campaign.get("name")}</div>
                <SVG
                  icon="iconEditCampaign"
                  className={css.editIcon}
                  onClick={this.handleEditName}
                />
              </div>
            )}
          </div>
          <div className={css2.right}>
            <Button
              loading={loading}
              onClick={this.handleToggleCampaign}
              className={css.endCampaignButton}
            >
              {active ? "End" : "Reinstate"} Campaign
            </Button>
            {!active ? null : (
              <SolidButton
                url={campaignPath(`${campaign.get("id")}/activity`)}
                className={css.newActivityButton}
              >
                New Activity
              </SolidButton>
            )}
          </div>
        </div>
        <div className={classNames(css2.content, css.content)}>
          <div className={css2.contentInner}>
            <div className={classNames(css.panel, css.topBar)}>
              <div className={css.campaignInfo}>
                <img
                  src={rocketImage}
                  alt="logo"
                  className={classNames(css.logo, css.logoRounded)}
                />
                <div>
                  <div className={css.title}>Campaign Start Date</div>
                  <div className={css.value}>
                    {formatLongDate(campaign.get("createDate"))}
                  </div>
                </div>
              </div>
              <div className={css.websiteInfo}>
                {websiteId ? (
                  <div className={css.website}>
                    <div className={css.websiteText}
                      onClick={() => {
                        window.open(url, "_blank");
                      }}
                    >
                      {url.substr(url.indexOf("www."))}
                    </div>
                  </div>
                ) : null}
                {!active && !websiteId ? null : (
                  <SolidButton
                    url={campaignPath(`${id}/website`)}
                    className={css.setupWebsiteButton}
                  >
                    {websiteId ? "Edit Website" : "Setup Website"}
                  </SolidButton>
                )}
              </div>
            </div>
            <div className={css.totalBar}>
              <div className={css.totalBarInner}>
                {!displayedTotals
                  ? null
                  : displayedTotals.map(({ icon, caption, value }) => (
                    <div className={css.total} key={caption}>
                      <div className={css.iconWrapper}>
                        <SVG icon={icon} className={css.icon} />
                      </div>
                      <div className={css.top}>
                        <div className={css.caption}>{caption}</div>
                        <div className={css.value}>
                          {value === null ? "—" : value}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div className={css.container}>
              <div className={css.directMailUpgradeBanner}>
                <DirectMailCampaignStats marketingCampaign={this.props.campaign} />
                <DirectMailUpgradeBanner />
              </div>
              <div className={css.directMailItems}>
                <div className={css.cardsScroller}>
                  <div className={css.cardsRow}>
                    {postcardCampaigns.size > 0 && (
                      <div className={css.cardsScroller}>
                        <div className={css.cardsRow}>
                          {this.getProcessedCampaigns(postcardCampaigns, id).map(
                            ({
                              item,
                              type,
                              publishDate,
                              sizeName,
                              externalId,
                              externalStatus
                            }) => (
                              <div
                                key={item.get("id")}
                                className={css.card}
                              >
                                <div className={css.top}>
                                  <div className={css.type}>
                                    {type.name}
                                    {!sizeName ? null : ` (${sizeName})`}
                                  </div>

                                  <div className={css.type}>
                                    Order# {item.get("id")}
                                    {!externalId ? null : `-${externalId}`}
                                  </div>
                                </div>

                                <div className={css.top}>
                                  <div className={css.name}>{item.get("name")}</div>

                                  <div
                                    className={classNames(
                                      publishDate
                                        ? css.statusPublished
                                        : css.statusUnpublished,
                                      !publishDate && css.statusUnpublishedText
                                    )}
                                  >
                                    {publishDate ? "Published" : "Unpublished"}
                                  </div>
                                </div>

                                <div className={css.lastEdit}>
                                  <span className={publishDate ? css.bold : ""}>
                                    {publishDate ? "Published" : "Last Edited"}:
                                  </span>{" "}
                                  <span className={css.value}>
                                    {formatLongDate(
                                      publishDate || item.get("updateDate")
                                    )}
                                  </span>

                                  {!externalStatus ? null : (
                                    <span className={css.status}>
                                      <span className={css.head}>Status:</span>{" "}
                                      <span className={css.head2}>
                                        {externalStatus}
                                      </span>
                                    </span>
                                  )}
                                </div>

                                <div className={css.bottom}>
                                  <div className={css.preview}>
                                    {item.get("previewUrl") && (
                                      <Image
                                        src={formatServerUrl(item.get("previewUrl"))}
                                        alt="preview"
                                      />
                                    )}
                                  </div>

                                  <div className={css.info}>
                                    {type.stats.map(stat => (
                                      <div className={css.row} key={stat.field}>
                                        <div className={css.value}>
                                          {item.get(stat.field, 0)}
                                        </div>

                                        <div className={css.caption}>
                                          {stat.label}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>

                                <div
                                  className={css.viewLeads}
                                  onClick={(e) => {
                                    console.log(item.toJS(), "items");
                                    console.log(item.get("contactIds"));
                                    e.preventDefault();
                                    e.stopPropagation();

                                    this.props.openContactAssignmentPopup({
                                      ids: this.props.campaign.get("contactIds") || [],
                                      viewMode: true,
                                    });
                                  }}
                                >
                                  <span>View Leads</span>
                                </div>

                              </div>
                            )
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* <DirectMailCampaignStats marketingCampaign={this.props.campaign} /> */}

            {!campaigns.size ? (active && <Activities />) : (
              <>
                {Object.values(CampaignTypes)
                  .filter(
                    type => (type.code === CampaignTypes.DIALER.code
                      || type.code === CampaignTypes.EMAIL.code) && campaigns.some(c => c.get("type") === type.code))
                  .sort((a, b) => {
                    if (a.code === CampaignTypes.DIALER.code) return -1;
                    if (b.code === CampaignTypes.DIALER.code) return 1;
                    return 0;
                  })
                  .map(type => {
                    const groupedItems = campaigns.filter(c => c.get("type") === type.code);
                    return (
                      <div className={css.items} key={type.code}>
                        <div className={css.itemsHeader}>
                          <div className={css.activityHeader}>
                            <div className={css.activityLeft}>
                              <div className={css.headerIcon}>
                                <SVG
                                  icon={this.getIconForType(type)}
                                  className={classNames(
                                    type.code === CampaignTypes.EMAIL.code
                                      ? css.headerEmailSvg
                                      : css.headerSvg
                                  )}
                                />
                              </div>
                              <div>
                                <div className={css.headerTitle}>
                                  {type.name}
                                </div>
                                <div className={css.headerCount}>
                                  {groupedItems.size} Activities
                                </div>
                              </div>
                            </div>

                            <div className={css.headerRight}>
                              <button
                                className={
                                  this.state.viewMode[type.code] === "card"
                                    ? css.activeView
                                    : css.viewButton
                                }
                                onClick={() =>
                                  this.handleViewToggle(type.code, "card")
                                }
                              >
                                <SVG icon="iconMenu" className={css.toogleSvg} />
                                Card
                              </button>

                              <button
                                className={
                                  this.state.viewMode[type.code] === "table"
                                    ? css.activeView
                                    : css.viewButton
                                }
                                onClick={() =>
                                  this.handleViewToggle(type.code, "table")
                                }
                              >
                                <SVG icon="iconTable" className={css.toogleSvg} />
                                Table
                              </button>
                            </div>
                          </div>
                        </div>
                        {this.state.viewMode[type.code] === 'card' ? (
                          <div className={css.cardsScroller}>
                            <div className={css.cardsRow}>
                              {this.getProcessedCampaigns(groupedItems, id).map(({ item, type, publishDate, sizeName, externalId, externalStatus, status, isProgressInactive, isActive, isDialer, active }) => (
                                <RouterLink
                                  to={{
                                    pathname: campaignPath(
                                      `${id}/${type?.route || ""}/${item.get("id")}`
                                    ),
                                    state: { dialerItem: item }
                                  }}
                                  className={css.card}
                                  key={item.get("id")}
                                >
                                  <div className={css.top}>
                                    <div className={css.type}>
                                      {type?.name}
                                      {!sizeName ? null : ` (${sizeName})`}
                                    </div>
                                    {!isDialer && (
                                      <div className={css.type}>
                                        Order# {item.get("id")}
                                        {!externalId ? null : `-${externalId}`}
                                      </div>
                                    )}
                                  </div>
                                  <div className={css.top}>
                                    <div className={css.name}>{item.get("name")}</div>
                                    <div className={classNames(
                                      active ? css.statusPublished : css.statusUnpublished,
                                      !isDialer && !publishDate && css.statusUnpublishedText
                                    )}>
                                      {isDialer
                                        ? (isActive ? "Active" : "Inactive")
                                        : (publishDate ? "Published" : "Unpublished")}
                                    </div>
                                  </div>
                                  {!isDialer && (
                                    <>
                                      <div className={css.lastEdit}>
                                        <span className={publishDate ? css.bold : ""}>
                                          {publishDate ? "Published" : "Last Edited"}:
                                        </span>{" "}
                                        <span className={css.value}>
                                          {formatLongDate(publishDate || item.get("updateDate"))}
                                        </span>
                                        {!externalStatus ? null : (
                                          <span className={css.status}>
                                            <span className={css.head}>Status:</span> <span className={css.head2}>{externalStatus}</span>
                                          </span>
                                        )}
                                      </div>
                                      <div className={css.bottom}>
                                        <div className={css.preview}>
                                          {!item.get("previewUrl") ? null : (
                                            <Image
                                              src={formatServerUrl(item.get("previewUrl"))}
                                              alt="preview"
                                            />
                                          )}
                                        </div>
                                        <div className={css.info}>
                                          {type?.stats.map(stat => (
                                            <div className={css.row} key={stat.field}>
                                              <div className={css.value}>
                                                {item.get(stat.field, 0)}
                                              </div>
                                              <div className={css.caption}>{stat.label}</div>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </>
                                  )}
                                  {isDialer && (
                                    <div className={css.dialerContainer}>
                                      <ProgressBar
                                        value={(() => {
                                          const contactedCount = item.get("deliveredQuantity");
                                          const recipientTotal = item.get("recipientTotal");
                                          if (!isNaN(contactedCount) && !isNaN(recipientTotal)) {
                                            return Math.floor(contactedCount / recipientTotal * 100);
                                          }
                                          return 0;
                                        })()}
                                        inactive={isProgressInactive} />
                                      <div className={css.LeadContainer}>
                                        <div className={css.dialerStatsGrid}>
                                          {CampaignTypes.DIALER.stats.map(stat => {
                                            let value = item.get(stat.field);
                                            if (stat.field === "startDate" || stat.field === "lastCallDate") {
                                              value = value ? formatDate(value) : "—";
                                            }
                                            if (value === undefined || value === null || value === "") {
                                              value = stat.field.includes("Date") ? "—" : 0;
                                            }
                                            return (
                                              <div className={css.dialerStat} key={stat.field}>
                                                <div className={css.dialerValue}>
                                                  {value}
                                                </div>
                                                <div className={css.dialerLabel}>
                                                  {stat.label}
                                                </div>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </RouterLink>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <div className={css.tableContainer}>
                            <CampaignTable
                              data={this.getProcessedCampaigns(groupedItems, id)}
                              type={type}
                              campaignId={id}
                            />
                          </div>
                        )}
                      </div>
                    );
                  })}
              </>
            )}
          </div>
        </div>
        <div className={css3.clsIntegrationCard}>
          <EndCampaignModal
            isOpen={this.state.showEndCampaignModal}
            onClose={this.handleCloseEndCampaignModal}
            onConfirm={this.handleConfirmToggleCampaign}
            active={active}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(
    state => ({
      loading: selectLoading(state),
      campaign: selectCampaign(state),
      profile: selectProfile(state),
      directMailStats: selectDirectMailCampaignStatsFor(state, selectCampaign(state).get('id'))
    }),
    {
      saveCampaign,
      confirm: Confirm.open,
      openContactAssignmentPopup: ContactAssignmentPopup.open,
    }
  )(Dashboard)
);